import { useEffect } from 'react';
import { useSettingsService } from '../GlobalSettingsProvider';
export function useDeleteSettings(keys, resolve, reject) {
  const {
    writeAccessState: {
      isWriteAccessDetected
    },
    dataProvider
  } = useSettingsService();
  useEffect(() => {
    let isMounted = true;
    async function _deleteSettings() {
      try {
        await dataProvider.deleteSettings(keys);
        if (isMounted) {
          resolve();
        }
      } catch (error) {
        if (isMounted) {
          reject();
        }
      }
    }
    if (isWriteAccessDetected && keys.length > 0) {
      _deleteSettings();
    }
    return () => {
      isMounted = false;
    };
  }, [isWriteAccessDetected, dataProvider, keys, resolve, reject]);
}
//# sourceMappingURL=useDeleteSettings.js.map